import { ScaleLib } from '@tunasong/music-lib'
import { type Scale } from '@tunasong/schemas'
import { getPromptSpec } from '../../get-prompt-spec.js'
import type { AIConfig } from '../../schema/ai-schema.js'
import { generatePromptSpec } from '../../generate-prompt.js'

export default ({
  title,
  lyrics,
  instrument,
  scale,
  style,
  userConfig,
  bpm = 120,
}: {
  /** Title of song/document */
  title: string
  style?: string
  lyrics: string
  scale: Scale
  instrument?: string
  bpm?: number

  userConfig?: AIConfig
}) => {
  /** This prompt is for ElevenLabs - https://elevenlabs.io/docs/overview/capabilities/music/best-practices */
  const promptSpec = getPromptSpec({ context: 'song:music', userConfig: userConfig?.contexts['song:music'] })

  style = style ?? promptSpec.musicStyle

  const promptText = `
  Write a prompt for generating music based on the following information:

  Title: "${title}"
  BPM: ${bpm}
  Key: ${ScaleLib.getName(scale)}
  ${instrument ? `Instrument: ${instrument}. Make sure the instrument is the only one playing.` : ''}
  ${style ? `Style: ${style}` : ''}

  Lyrics:
  ${lyrics}
`
  return generatePromptSpec({
    promptText,
    context: 'song:music',
    userConfig: userConfig?.contexts['song:music'],
  })
}
